import { Link, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import {
    RiHomeLine,        RiHomeFill,
    RiFolder3Line,     RiFolder3Fill,
    RiUser3Line,       RiUser3Fill,
    RiBriefcaseLine,   RiBriefcaseFill,
    RiChatQuoteLine,   RiChatQuoteFill,
    RiMailLine,        RiMailFill,
} from "react-icons/ri";

const NAV_ITEMS = [
    { path: "/",              label: "Home",         Line: RiHomeLine,       Fill: RiHomeFill       },
    { path: "/projects",      label: "Projects",     Line: RiFolder3Line,    Fill: RiFolder3Fill    },
    { path: "/about",         label: "About",        Line: RiUser3Line,      Fill: RiUser3Fill      },
    { path: "/experience",    label: "Experience",   Line: RiBriefcaseLine,  Fill: RiBriefcaseFill  },
    { path: "/testimonials",  label: "Testimonials", Line: RiChatQuoteLine,  Fill: RiChatQuoteFill  },
    { path: "/contact",       label: "Contact",      Line: RiMailLine,       Fill: RiMailFill       },
];

const Navigation = () => {
    const location = useLocation();
    const handleLinkClick = () => window.scrollTo({ top: 0, behavior: "smooth" });
    const mobileNav = (
        <nav
            className="lg:hidden fixed left-1/2 z-[1100] flex items-center gap-0.5 px-2 py-2 rounded-2xl backdrop-blur-xl"
            style={{
                bottom: "max(16px, env(safe-area-inset-bottom))",
                transform: "translateX(-50%)",
                background: "rgba(4, 18, 36, 0.9)",
                border: "1px solid rgba(255,255,255,0.1)",
                boxShadow:
                    "0 8px 32px rgba(0,0,0,0.5), 0 0 0 1px rgba(255,255,255,0.03)",
            }}
        >
            {NAV_ITEMS.map(({ path, label, Line, Fill }) => {
                const isActive = location.pathname === path;
                const Icon = isActive ? Fill : Line;
                return (
                    <Link
                        key={path}
                        to={path}
                        onClick={handleLinkClick}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "2px",
                            padding: "7px 11px",
                            borderRadius: "12px",
                            color: isActive
                                ? "#C8972A"
                                : "rgba(255,255,255,0.4)",
                            background: isActive
                                ? "rgba(200,151,42,0.1)"
                                : "transparent",
                            transition: "all 0.15s ease",
                            textDecoration: "none",
                            minWidth: "46px",
                        }}
                    >
                        <Icon size={19} />
                        <span
                            style={{
                                fontSize: "9px",
                                fontWeight: isActive ? 600 : 400,
                                letterSpacing: "0.02em",
                            }}
                        >
                            {label}
                        </span>
                    </Link>
                );
            })}
        </nav>
    );

    return (
        <>
            {/* ── Desktop nav ─────────────────────────────── */}
            <nav
                className="hidden lg:flex items-center flex-wrap gap-1 mb-7 pb-5"
                style={{ borderBottom: "1px solid rgba(255,255,255,0.07)" }}
            >
                {NAV_ITEMS.map(({ path, label, Line, Fill }) => {
                    const isActive = location.pathname === path;
                    const Icon = isActive ? Fill : Line;
                    return (
                        <Link
                            key={path}
                            to={path}
                            onClick={handleLinkClick}
                            style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                padding: "7px 14px",
                                borderRadius: "8px",
                                fontSize: "13px",
                                fontWeight: isActive ? 600 : 400,
                                color: isActive
                                    ? "#C8972A"
                                    : "rgba(255,255,255,0.5)",
                                background: isActive
                                    ? "rgba(200,151,42,0.1)"
                                    : "transparent",
                                border: `1px solid ${
                                    isActive
                                        ? "rgba(200,151,42,0.25)"
                                        : "transparent"
                                }`,
                                transition: "all 0.15s ease",
                                textDecoration: "none",
                                letterSpacing: "0.01em",
                            }}
                            onMouseEnter={(e) => {
                                if (!isActive) {
                                    e.currentTarget.style.color =
                                        "rgba(255,255,255,0.85)";
                                    e.currentTarget.style.background =
                                        "rgba(255,255,255,0.06)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!isActive) {
                                    e.currentTarget.style.color =
                                        "rgba(255,255,255,0.5)";
                                    e.currentTarget.style.background =
                                        "transparent";
                                }
                            }}
                        >
                            <Icon size={15} />
                            {label}
                        </Link>
                    );
                })}
            </nav>

            {/* ── Mobile nav ──────────────────────────────── */}
            {typeof document !== "undefined"
                ? createPortal(mobileNav, document.body)
                : mobileNav}
        </>
    );
};

export default Navigation;
